export const GET_COURSE_REQUEST="GET_COURSE_REQUEST"
export const GET_COURSE_SUCCESS="GET_COURSE_SUCCESS"
export const GET_COURSE_ERROR="GET_COURSE_ERROR"

export const SINGAL_COURSE_REQUEST="SINGAL_COURSE_REQUEST"
export const SINGAL_COURSE_SUCCESS="SINGAL_COURSE_SUCCESS"
export const SINGAL_COURSE_ERROR="SINGAL_COURSE_ERROR"